import { useEffect } from "react";
import { AutocompleteInput, Filter } from "ra-ui-materialui";
import { isEmpty, useListContext } from "ra-core";
import { ActionTitles, THEMABLE_REPORT_TYPE_CHOICES } from "../Constants";
import { width } from "../Styles";

export const ReportThemeFilter = (props) => {

  const { clientChoices, reportThemeChoices, reportTemplates } = props;

  const { filterValues, setFilters } = useListContext();

  const filteredReportThemeChoices = isEmpty(filterValues?.reportType)
    ? reportThemeChoices
    : reportThemeChoices.filter((reportTheme) => reportTheme.reportType === filterValues.reportType);

  const filteredReportTemplateChoices = !isEmpty(filterValues?.reportThemeId)
    ? reportTemplates.filter((template) => template.reportThemeId === filterValues.reportThemeId)
    : !isEmpty(filterValues?.reportType)
    ? reportTemplates.filter((template) => template.reportType === filterValues.reportType)
    : reportTemplates;

  //When report type is changed, reset reportThemeId
  useEffect(() => {
    setFilters({ ...filterValues, reportThemeId: undefined, reportThemeTemplateId: undefined }, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterValues.reportType]);

  //When report theme is changed, reset reportThemeTemplateId
  useEffect(() => {
    setFilters({ ...filterValues, reportThemeTemplateId: undefined }, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterValues.reportThemeId]);

  return (
    <Filter variant="outlined" {...props}>
      <AutocompleteInput
        id="report-theme-filter-client-input"
        source="clientId"
        name="clientId" //check this while integration
        variant="outlined"
        size="small"
        label={ActionTitles.CORPORATE_PARTNER}
        choices={clientChoices}
        resettable
        sx={width.fixed.w200}
        alwaysOn
      />
      <AutocompleteInput
        id="report-theme-filter-report-type-input"
        label="Report Type"
        source="reportType"
        choices={THEMABLE_REPORT_TYPE_CHOICES}
        variant="outlined"
        size="small"
        sx={width.fixed.w250}
        resettable
        alwaysOn
      />
      <AutocompleteInput
        id="report-theme-filter-report-theme-input"
        source="reportThemeId"
        name="reportThemeId"
        variant="outlined"
        size="small"
        label={ActionTitles.REPORT_THEMES}
        choices={filteredReportThemeChoices}
        resettable
        sx={width.fixed.w200}
        alwaysOn
      />
      <AutocompleteInput
        id="report-theme-filter-report-template-input"
        source="reportThemeTemplateId"
        name="reportThemeTemplateId"
        variant="outlined"
        size="small"
        label="Report Template"
        choices={filteredReportTemplateChoices}
        resettable
        sx={width.fixed.w200}
        alwaysOn
      />
    </Filter>
  );
};